import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react'
import {
    View,
    TouchableOpacity,
    Text,
    Animated,
    Platform,
    Image,
    Linking,
} from 'react-native'
import { useNavigation, useRoute } from '@react-navigation/native'
import { Feather } from '@expo/vector-icons'
import { useFooterApp } from '../../redux/zustand/footerAppStore'
import { getData } from '../appBar/context/HeaderContext'
import { eventEmitter, platformSelect } from '../../utils/functions.utils'
import PostsList from '../posts/PostsList'
import styles from './WebSidebarStyles'
import theme from '../../../theme'
import { UserServices } from '../../../database/user.database'
import { AntDesign, Ionicons } from '@expo/vector-icons'
import WebSidebarSkeleton from './WebSidebarSkeleton'
import Constants from 'expo-constants'
import { DotiFooter } from '../navigation/DotiFooter'

const WebSidebar = ({
    collapsed = false,
    isMobile = false,
    closeSideBar = () => {},
}) => {
    // Safe navigation hooks - only use if inside navigator
    let navigation, route, routeName
    try {
        navigation = useNavigation()
        route = useRoute()
        routeName = route?.name || 'Main'
    } catch (error) {
        // Not inside navigator context
        navigation = null
        route = null
        routeName = 'Main'
    }

    const { setCurrentFooterRoute, footerRoute } = getData()
    const footer_app = useFooterApp((state) => state.footer_app)
    const setFooterApp = useFooterApp((state) => state.setFooterApp)
    const [sidebarHeight, setSidebarHeight] = useState(82)
    const [localFooterData, setLocalFooterData] = useState(null)
    const [deadlinePassed, setDeadlinePassed] = useState(false)

    // Debug: Verificar qué datos están mostrando
    // console.log('[WebSidebar] 📋 Estado actual:')
    // console.log(
    //     '  - footer_app (store):',
    //     footer_app ? `${footer_app.length} items` : 'null',
    //     footer_app?.map((i) => i.label),
    // )
    // console.log(
    //     '  - localFooterData:',
    //     localFooterData ? `${localFooterData.length} items` : 'null',
    //     localFooterData?.map((i) => i.label),
    // )
    // console.log('  - collapsed:', collapsed)
    // console.log('  - isMobile:', isMobile)

    // Cargar footer_app sólo si no se inicializó vía hook global (fallback defensivo)
    useEffect(() => {
        let cancelled = false
        const loadFooterData = async () => {
            if (Platform.OS !== 'web') return
            if (footer_app && footer_app.length > 0) return
            try {
                const footerData = await UserServices.getFooterApp()
                console.log('FOOTER DATA ==>', footerData)
                if (!cancelled) {
                    if (Array.isArray(footerData) && footerData.length > 0) {
                        setFooterApp(footerData)
                        setLocalFooterData(footerData)
                    } else {
                        setLocalFooterData([])
                    }
                }
            } catch (e) {
                if (!cancelled) setLocalFooterData([])
            }
        }
        loadFooterData()
        const t = setTimeout(() => setDeadlinePassed(true), 8000)
        return () => {
            cancelled = true
            clearTimeout(t)
        }
    }, [footer_app, setFooterApp])

    // Mapeo de íconos exacto de TabsNavigation.js
    const expoConfig = Constants.expoConfig || { slug: '' }

    const getIconForRoute = (routeName, focused = false) => {
        const color = focused
            ? theme.colors.colorPrimary
            : theme.colors.textSecondary
        const size = 20

        // console.log('WebSidebar - getIconForRoute called with:', routeName, 'focused:', focused)

        // Mapeo exacto basado en tabsScreens de TabsNavigation.js
        switch (routeName) {
            case 'PostsList':
                return <AntDesign name='rocket' size={size} color={color} />
            case 'LearningHome':
                return <Feather name='book' size={size} color={color} />
            case 'Schedule':
                return <Feather name='map-pin' size={size} color={color} />
            case 'CreateScheduleModerator':
                return <Feather name='map-pin' size={size} color={color} />
            case 'Portfolio':
                const portfolioIcon =
                    expoConfig.slug === 'dots' || expoConfig.slug === 'branca-one'
                        ? 'grid'
                        : 'briefcase'
                return <Feather name={portfolioIcon} size={size} color={color} />
            case 'BenefitsHome':
                return <Feather name='award' size={size} color={color} />
            case 'WiseScreen':
                return <Feather name='file' size={size} color={color} />
            case 'MyAdvance':
                return <Feather name='trending-up' size={size} color={color} />
            case 'ScheduleDistributor':
                return <Feather name='map-pin' size={size} color={color} />
            case 'VouchersScreen':
                return <Feather name='camera' size={size} color={color} />
            case 'Trivia':
                return <Feather name='star' size={size} color={color} />
            case 'Gamification':
                return (
                    <Ionicons
                        name='game-controller-outline'
                        size={size + 4}
                        color={color}
                    />
                )
            case 'Ranking':
                // Usar ícono alternativo para web en lugar de imagen
                return (
                    <Image
                        source={require('../../../assets/footer_RankingIcon.png')}
                        style={{ width: size, height: size, tintColor: color }}
                    />
                )
            case 'Profile':
                return <Feather name='user' size={size} color={color} />
            // Casos adicionales que pueden venir del backend
            case 'Posts':
                return <AntDesign name='rocket' size={size} color={color} />
            case 'Learning':
                return <Feather name='book' size={size} color={color} />
            case 'Benefits':
                return <Feather name='award' size={size} color={color} />
            // case 'Doti':
            //     return (
            //         <DotiFooter styles={{ width: 30, height: 30 }} isActive={true} />
            //     )
            case 'Dashboard':
                return <Ionicons name='stats-chart' size={size} color={color} />
            case 'link':
                return <Ionicons name='football-outline' size={size} color={color} />
            case 'chatbot':
                return (
                    <Image
                        source={require('../../../assets/Chatbot.png')}
                        style={{
                            width: size,
                            height: size,
                            tintColor: theme.colors.colorPrimary,
                        }}
                    />
                )
            default:
                console.log(
                    'WebSidebar - No icon found for route:',
                    routeName,
                    '- using default',
                )
                return <Feather name='circle' size={size} color={color} />
        }
    }

    // El control de colapso ahora viene desde WebLayout; persistencia opcional podría moverse allí si se requiere

    const canonicalRoute = (label) => {
        switch (label) {
            case 'Posts':
            case 'PostsList':
                return 'PostsList'
            case 'Learning':
            case 'LearningHome':
                return 'LearningHome'
            case 'Benefits':
            case 'BenefitsHome':
                return 'BenefitsHome'
            default:
                return label
        }
    }

    const handleTabPress = async (tabButton) => {
        if (!tabButton?.label) return

        if (!!tabButton.link) {
            let url = tabButton.link ?? ''
            let canOpen = url != null && url != undefined && url != ''
            console.log('handleTabPress - Dashboard URL:', url, 'canOpen:', canOpen)
            if (canOpen) {
                await Linking.openURL(url)
            } else {
                alert('Url no valida')
            }
            console.log('Opening Dashboard URL:', tabButton)
            return
        }
        const target = canonicalRoute(tabButton.label)
        console.log('[WebSidebar] handleTabPress -> target:', target)
        setCurrentFooterRoute(target)
        if (isMobile) closeSideBar()

        // En web, no usamos navigation.navigate() porque bypasseamos el Stack
        // El cambio de footerRoute causará re-render en NavigationStack
    }

    // Filtrado consistente con TabsNavigation: item.nav == false && item.section == false
    // Aceptar múltiples representaciones de false, incluyendo strings "true" y "false"
    const isFalsy = (val) => {
        // Si es un string "false", "0", o vacío, es falsy
        if (typeof val === 'string') {
            const lower = val.toLowerCase().trim()
            return lower === 'false' || lower === '0' || lower === ''
        }
        // Para otros tipos, usar truthiness estándar
        return (
            !val || val === 0 || val === false || val === null || val === undefined
        )
    }

    const visibleItems = useMemo(() => {
        const source = footer_app || localFooterData || []
        if (!Array.isArray(source)) {
            console.log('[WebSidebar] Source is not an array:', typeof source)
            return []
        }
        console.log(
            '[WebSidebar] Filtering from source:',
            source.length,
            'items',
            source,
        )
        const filtered = source.filter((item) => {
            if (!item || !item.label) {
                console.log('[WebSidebar] Skipping item without label:', item)
                return false
            }
            const navFalsy = isFalsy(item.nav)
            const sectionFalsy = isFalsy(item.section)
            console.log(
                '[WebSidebar] Item:',
                item.label,
                'nav:',
                item.nav,
                '(type:',
                typeof item.nav,
                ') →',
                navFalsy,
                'section:',
                item.section,
                '(type:',
                typeof item.section,
                ') →',
                sectionFalsy,
                'included:',
                navFalsy && sectionFalsy,
            )
            return navFalsy && sectionFalsy
        })
        console.log(
            '[WebSidebar] Filtered result:',
            filtered.length,
            'items:',
            filtered.map((i) => i.label),
        )
        return filtered
    }, [footer_app, localFooterData])

    // Log resumido una sola vez cuando se obtiene la primera lista visible
    const loggedOnceRef = useRef(false)
    useEffect(() => {
        if (!loggedOnceRef.current && visibleItems.length > 0) {
            console.log(
                '[WebSidebar] Resumen inicial -> totalFuente:',
                (footer_app || localFooterData || []).length,
                'visibles:',
                visibleItems.length,
                'labels:',
                visibleItems.map((i) => i.label),
            )
            loggedOnceRef.current = true
        }
    }, [visibleItems, footer_app, localFooterData])

    const blockedSections = ['Schedule']
    const renderTab = (tabButton) => {
        if (!tabButton) return null

        if (blockedSections.includes(canonicalRoute(tabButton.label))) return

        const activeByRoute = canonicalRoute(tabButton.label) === routeName
        const activeByFooter =
            canonicalRoute(tabButton.label) === canonicalRoute(footerRoute)
        const isActive = activeByRoute || activeByFooter
        const icon = getIconForRoute(tabButton.label, isActive)
        const name = tabButton.name || tabButton.label
        return (
            <TouchableOpacity
                key={tabButton._id || tabButton.label}
                style={[styles.sidebarItem, isActive && styles.sidebarItemActive]}
                onPress={() => handleTabPress(tabButton)}
                activeOpacity={0.7}
            >
                <View
                    style={[
                        styles.sidebarItemContent,
                        collapsed && styles.sidebarItemContentCollapsed,
                    ]}
                >
                    <View
                        style={[
                            styles.tabIcon,
                            collapsed && styles.tabIconCollapsed,
                        ]}
                    >
                        {icon}
                    </View>
                    <Text
                        style={[
                            styles.sidebarItemText,
                            isActive
                                ? styles.sidebarItemTextActive
                                : styles.sidebarItemTextInactive,
                            collapsed && styles.sidebarItemTextCollapsed,
                        ]}
                    >
                        {name}
                    </Text>
                </View>
            </TouchableOpacity>
        )
    }

    const translateX = useRef(new Animated.Value(0)).current

    const toggleSidebarVisibility = (visible) => {
        Animated.timing(translateX, {
            toValue: visible ? 0 : -250, // Desliza hacia la izquierda o muestra
            duration: 600,
            useNativeDriver: true,
        }).start()
        setSidebarHeight(visible ? 82 : 0)
    }

    useEffect(() => {
        const onStart = () => toggleSidebarVisibility(false)
        const onEnd = () => toggleSidebarVisibility(true)

        eventEmitter.on('hideSidebar', onStart)
        eventEmitter.on('showSidebar', onEnd)

        return () => {
            eventEmitter.removeListener('hideSidebar', onStart)
            eventEmitter.removeListener('showSidebar', onEnd)
        }
    }, [])

    // Determinar qué datos usar (footer_app del store o localFooterData)
    const footerData = footer_app || localFooterData
    const shouldShowSidebar = Array.isArray(visibleItems) && visibleItems.length > 0

    // Debug detallado
    // console.log('WebSidebar - RENDER DEBUG:')
    // console.log('WebSidebar - footer_app (store):', footer_app)
    // console.log('WebSidebar - localFooterData:', localFooterData)
    // console.log('WebSidebar - footerData (final):', footerData)
    // console.log('WebSidebar - shouldShowSidebar:', shouldShowSidebar)

    // Menos ruido en consola: sólo un resumen
    if (Array.isArray(visibleItems)) {
        // console.log(
        //     '[WebSidebar] Visible items:',
        //     visibleItems.map((i) => i.label),
        // )
    }

    if (!shouldShowSidebar) {
        return (
            <Animated.View
                style={[
                    styles.sidebarContainer,
                    collapsed && styles.sidebarContainerCollapsed,
                ]}
            >
                <View style={styles.sidebar}>
                    <WebSidebarSkeleton collapsed={collapsed} itemCount={6} />
                    {deadlinePassed && (
                        <View style={styles.alertBox}>
                            <Text style={styles.alertText}>
                                No se pudieron cargar los accesos de navegación.
                                Intenta recargar o verifica tu conexión.
                            </Text>
                        </View>
                    )}
                </View>
            </Animated.View>
        )
    }

    return (
        <Animated.View
            style={[
                styles.sidebarContainer,
                collapsed && styles.sidebarContainerCollapsed,
                {
                    transform: [{ translateX }],
                    height: sidebarHeight === 0 ? 0 : 'auto',
                },
            ]}
        >
            <View style={styles.sidebar}>
                {/* Título 'Navegación' removido: se muestran directamente los accesos */}
                <View style={styles.sidebarContent}>
                    {visibleItems.map((tabButton) => renderTab(tabButton))}
                </View>
            </View>
        </Animated.View>
    )
}

export default WebSidebar
